import { Suspense } from 'react';

import { useSuspenseQuery } from '@tanstack/react-query';
import { notFound, useSearch } from '@tanstack/react-router';

import { clientByIdOptions } from '@/entities/client';
import { Page } from '@/shared/ui/layout/page';
import { RecordingSession } from '@/widgets/session/recording-session';

import { RecordingPageFallback } from './recording-page/recording-page-fallback';

function RecordingContent({ clientId }: { clientId: string }) {
    const { data: client, isError } = useSuspenseQuery(clientByIdOptions(clientId));

    if (isError || !client) {
        throw notFound();
    }

    return <RecordingSession client={client} inputMethod="DICTATION" />;
}

export function RecordingPage() {
    const { clientId } = useSearch({ from: '/recording' });

    if (!clientId) {
        return null;
    }

    return (
        <Page>
            <Suspense fallback={<RecordingPageFallback />}>
                <RecordingContent clientId={clientId} />
            </Suspense>
        </Page>
    );
}
